<template>
  <div class="calendar">
    <div class="calendar-header flex flex-between">
      <div class="flex flex-start item-center">
        <div>
          <!-- <span
          class="iconfont icon-zuoshuangjiantou1"
          @click="toLastYear"
        ></span> -->
          <span
            class="hmicon icon-mjiantou-copy pointer"
            style="display:inline-block;"
            @click="toLastMonth"
          ></span>
        </div>
        <div style="margin:0 20px">{{ currentYear }}年{{ currentMonth }}月</div>
        <div>
          <span
            class="hmicon icon-icon-youjiantou pointer"
            @click="toNextMonth"
          ></span>
          <!-- <span
          class="iconfont icon-youshuangjiantou1"
          @click="toNextYear"
        ></span> -->
        </div>
      </div>
      <div>
        <el-button plain size="small" class="mr10" @click="goToday"
          >今天</el-button
        >
        <el-radio-group size="small" v-model="calendarType">
          <el-radio-button label="day">月</el-radio-button>
          <el-radio-button label="month">
            年
          </el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <table
      cellspacing="0"
      cellpadding="0"
      class="el-calendar-table"
      v-if="calendarType === 'day'"
    >
      <thead>
        <th v-for="(v, i) in weeks" :key="i">周{{ v }}</th>
      </thead>
      <tbody>
        <tr class="days" v-for="(j, k) in calendarList" :key="k">
          <td v-for="(v, i) in j" :key="i" width="200">
            <div class="pc-calendar-day" @click="selectDay(v)">
              <!-- @click="selectDay(v)" -->
              <!-- 下标{{ k * 7 + i }} -->

              <div style="height:100%" v-if="k === 0">
                <el-popover
                  trigger="click"
                  class="item"
                  width="500"
                  placement="right"
                  :disabled="v.actList.length === 0"
                >
                  <el-table
                    :data="v.actList"
                    style="width: 100%"
                    size="small"
                    height="400"
                  >
                    <el-table-column
                      width="50"
                      prop="planName"
                      label="序号"
                      type="index"
                    ></el-table-column>
                    <el-table-column
                      prop="planName"
                      label="活动名称"
                    ></el-table-column>
                    <el-table-column
                      prop="startTime"
                      label="活动开始时间"
                    ></el-table-column>
                    <el-table-column
                      prop="endTime"
                      label="活动结束时间"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button
                          size="small"
                          type="text"
                          @click="planDetails(scope.row)"
                          >详情</el-button
                        >
                        <el-button
                          size="small"
                          type="text"
                          @click="remove(scope.row)"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <div slot="reference">
                    <div
                      class="day pointer flex flex-between"
                      :class="{ 'not-current-month': v.isCurentMonth !== 0 }"
                    >
                      <span v-if="v.count" class="badge">
                        {{ v.count }}
                      </span>
                      <span
                        :class="{ currentDay: currentDate.date === v.date }"
                        >{{ v.day }}</span
                      >
                      <span>{{ v.lunar }}</span>
                      <span
                        v-if="v.hasCheckedIn"
                        class="iconfont icon-gou2"
                      ></span>
                    </div>

                    <div>
                      <div v-for="(item, index) in calendarData0" :key="index">
                        <div v-if="index < 2">
                          <el-popover
                            placement="right"
                            width="500"
                            :disabled="calendarData0.length === 0"
                            trigger="hover"
                            :open-delay="1000"
                          >
                            <div class="p10 ">
                              <div class="flex flex-wrap one-plan">
                                <div
                                  class="one-plan-content"
                                  style="fontWeight:600"
                                >
                                  <div>
                                    计划名称：
                                  </div>
                                  <div>
                                    计划时间：
                                  </div>
                                  <div>
                                    计划描述：
                                  </div>
                                </div>
                                <div class="flex-1 one-plan-content">
                                  <div>
                                    {{ item.planName }}
                                  </div>
                                  <div>
                                    {{ item.startTime }}至{{ item.endTime }}
                                  </div>
                                  <div>
                                    {{ item.planRemark }}
                                  </div>
                                </div>
                              </div>

                              <div class="flex flex-center">
                                <el-button
                                  type="primary"
                                  size="small"
                                  @click="planDetails(item)"
                                  >查看计划详情</el-button
                                >
                              </div>
                            </div>
                            <div slot="reference">
                              <div
                                class="is-select-plan oneLine"
                                v-if="item.locateIndex[0] === k * 7 + i"
                                :style="
                                  `background:${item.color.background};color:${item.color.color};borderLeft:3px solid ${item.color.color}`
                                "
                              >
                                {{ item.planName }}
                              </div>

                              <div
                                v-if="
                                  item.locateIndex[0] < k * 7 + i &&
                                    k <= item.endRowIndex
                                "
                                class="is-select-plan oneLine"
                                :style="{
                                  background:
                                    item.locateIndex[0] < k * 7 + i &&
                                    item.locateIndex[
                                      item.locateIndex.length - 1
                                    ] >=
                                      k * 7 + i
                                      ? item.color.background
                                      : '',
                                  color:
                                    item.locateIndex[0] < k * 7 + i &&
                                    item.locateIndex[
                                      item.locateIndex.length - 1
                                    ] >=
                                      k * 7 + i
                                      ? item.color.color
                                      : '',
                                  borderLeft:
                                    (k * 7 + i) % 7 === 0
                                      ? `3px solid ${item.color.color}`
                                      : ''
                                }"
                              >
                                {{ (k * 7 + i) % 7 === 0 ? item.planName : "" }}
                              </div>
                            </div>
                          </el-popover>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-popover>
              </div>
              <div style="height:100%" v-if="k === 1">
                <el-popover
                  trigger="click"
                  class="item"
                  width="500"
                  placement="right"
                  :disabled="v.actList.length === 0"
                >
                  <el-table
                    :data="v.actList"
                    style="width: 100%"
                    size="small"
                    height="400"
                  >
                    <el-table-column
                      width="50"
                      prop="planName"
                      label="序号"
                      type="index"
                    ></el-table-column>
                    <el-table-column
                      prop="planName"
                      label="活动名称"
                    ></el-table-column>
                    <el-table-column
                      prop="startTime"
                      label="活动开始时间"
                    ></el-table-column>
                    <el-table-column
                      prop="endTime"
                      label="活动结束时间"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button
                          size="small"
                          type="text"
                          @click="planDetails(scope.row)"
                          >详情</el-button
                        >
                        <el-button
                          size="small"
                          type="text"
                          @click="remove(scope.row)"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <div slot="reference">
                    <div
                      class="day pointer flex flex-between"
                      :class="{ 'not-current-month': v.isCurentMonth !== 0 }"
                    >
                      <span v-if="v.count" class="badge">
                        {{ v.count }}
                      </span>
                      <span
                        :class="{ currentDay: currentDate.date === v.date }"
                        >{{ v.day }}</span
                      >
                      <span>{{ v.lunar }}</span>
                      <span
                        v-if="v.hasCheckedIn"
                        class="iconfont icon-gou2"
                      ></span>
                    </div>

                    <div v-if="calendarData1.length">
                      <div v-for="(item, index) in calendarData1" :key="index">
                        <div v-if="index < 2">
                          <el-popover
                            placement="right"
                            width="500"
                            trigger="hover"
                            :open-delay="1000"
                          >
                            <div class="p10 ">
                              <div class="flex flex-wrap one-plan">
                                <div
                                  class="one-plan-content"
                                  style="fontWeight:600"
                                >
                                  <div>
                                    计划名称：
                                  </div>
                                  <div>
                                    计划时间：
                                  </div>
                                  <div>
                                    计划描述：
                                  </div>
                                </div>
                                <div class="flex-1 one-plan-content">
                                  <div>
                                    {{ item.planName }}
                                  </div>
                                  <div>
                                    {{ item.startTime }}至{{ item.endTime }}
                                  </div>
                                  <div>
                                    {{ item.planRemark }}
                                  </div>
                                </div>
                              </div>

                              <div class="flex flex-center">
                                <el-button
                                  type="primary"
                                  size="small"
                                  @click="planDetails(item)"
                                  >查看计划详情</el-button
                                >
                              </div>
                            </div>
                            <div slot="reference">
                              <div
                                class="is-select-plan oneLine"
                                v-if="item.locateIndex[0] === k * 7 + i"
                                :style="
                                  `background:${item.color.background};color:${item.color.color};borderLeft:3px solid ${item.color.color}`
                                "
                              >
                                {{ item.planName }}
                              </div>

                              <div
                                v-if="
                                  item.locateIndex[0] < k * 7 + i &&
                                    k <= item.endRowIndex
                                "
                                class="is-select-plan oneLine"
                                :style="{
                                  background:
                                    item.locateIndex[0] < k * 7 + i &&
                                    item.locateIndex[
                                      item.locateIndex.length - 1
                                    ] >=
                                      k * 7 + i
                                      ? item.color.background
                                      : '',
                                  color:
                                    item.locateIndex[0] < k * 7 + i &&
                                    item.locateIndex[
                                      item.locateIndex.length - 1
                                    ] >=
                                      k * 7 + i
                                      ? item.color.color
                                      : '',
                                  borderLeft:
                                    (k * 7 + i) % 7 === 0
                                      ? `3px solid ${item.color.color}`
                                      : ''
                                }"
                              >
                                {{ (k * 7 + i) % 7 === 0 ? item.planName : "" }}
                              </div>
                            </div>
                          </el-popover>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-popover>
              </div>
              <div style="height:100%" v-if="k === 2">
                <el-popover
                  trigger="click"
                  class="item"
                  width="500"
                  placement="right"
                  :disabled="v.actList.length === 0"
                >
                  <el-table
                    :data="v.actList"
                    style="width: 100%"
                    size="small"
                    height="400"
                  >
                    <el-table-column
                      width="50"
                      prop="planName"
                      label="序号"
                      type="index"
                    ></el-table-column>
                    <el-table-column
                      prop="planName"
                      label="活动名称"
                    ></el-table-column>
                    <el-table-column
                      prop="startTime"
                      label="活动开始时间"
                    ></el-table-column>
                    <el-table-column
                      prop="endTime"
                      label="活动结束时间"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button
                          size="small"
                          type="text"
                          @click="planDetails(scope.row)"
                          >详情</el-button
                        >
                        <el-button
                          size="small"
                          type="text"
                          @click="remove(scope.row)"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <div slot="reference">
                    <div
                      class="day pointer flex flex-between"
                      :class="{ 'not-current-month': v.isCurentMonth !== 0 }"
                    >
                      <span v-if="v.count" class="badge">
                        {{ v.count }}
                      </span>
                      <span
                        :class="{ currentDay: currentDate.date === v.date }"
                        >{{ v.day }}</span
                      >
                      <span>{{ v.lunar }}</span>
                      <span
                        v-if="v.hasCheckedIn"
                        class="iconfont icon-gou2"
                      ></span>
                    </div>

                    <div v-if="calendarData2.length">
                      <div v-for="(item, index) in calendarData2" :key="index">
                        <div v-if="index < 2">
                          <el-popover
                            placement="right"
                            width="500"
                            trigger="hover"
                            :open-delay="1000"
                          >
                            <div class="p10 ">
                              <div class="flex flex-wrap one-plan">
                                <div
                                  class="one-plan-content"
                                  style="fontWeight:600"
                                >
                                  <div>
                                    计划名称：
                                  </div>
                                  <div>
                                    计划时间：
                                  </div>
                                  <div>
                                    计划描述：
                                  </div>
                                </div>
                                <div class="flex-1 one-plan-content">
                                  <div>
                                    {{ item.planName }}
                                  </div>
                                  <div>
                                    {{ item.startTime }}至{{ item.endTime }}
                                  </div>
                                  <div>
                                    {{ item.planRemark }}
                                  </div>
                                </div>
                              </div>

                              <div class="flex flex-center">
                                <el-button
                                  type="primary"
                                  size="small"
                                  @click="planDetails(item)"
                                  >查看计划详情</el-button
                                >
                              </div>
                            </div>
                            <div slot="reference">
                              <div
                                class="is-select-plan oneLine"
                                v-if="item.locateIndex[0] === k * 7 + i"
                                :style="
                                  `background:${item.color.background};color:${item.color.color};borderLeft:3px solid ${item.color.color}`
                                "
                              >
                                {{ item.planName }}
                              </div>

                              <div
                                v-if="
                                  item.locateIndex[0] < k * 7 + i &&
                                    k <= item.endRowIndex
                                "
                                class="is-select-plan oneLine"
                                :style="{
                                  background:
                                    item.locateIndex[0] < k * 7 + i &&
                                    item.locateIndex[
                                      item.locateIndex.length - 1
                                    ] >=
                                      k * 7 + i
                                      ? item.color.background
                                      : '',
                                  color:
                                    item.locateIndex[0] < k * 7 + i &&
                                    item.locateIndex[
                                      item.locateIndex.length - 1
                                    ] >=
                                      k * 7 + i
                                      ? item.color.color
                                      : '',
                                  borderLeft:
                                    (k * 7 + i) % 7 === 0
                                      ? `3px solid ${item.color.color}`
                                      : ''
                                }"
                              >
                                {{ (k * 7 + i) % 7 === 0 ? item.planName : "" }}
                              </div>
                            </div>
                          </el-popover>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-popover>
              </div>
              <div style="height:100%" v-if="k === 3">
                <el-popover
                  trigger="click"
                  class="item"
                  width="500"
                  placement="right"
                  :disabled="v.actList.length === 0"
                >
                  <el-table
                    :data="v.actList"
                    style="width: 100%"
                    size="small"
                    height="400"
                  >
                    <el-table-column
                      width="50"
                      prop="planName"
                      label="序号"
                      type="index"
                    ></el-table-column>
                    <el-table-column
                      prop="planName"
                      label="活动名称"
                    ></el-table-column>
                    <el-table-column
                      prop="startTime"
                      label="活动开始时间"
                    ></el-table-column>
                    <el-table-column
                      prop="endTime"
                      label="活动结束时间"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button
                          size="small"
                          type="text"
                          @click="planDetails(scope.row)"
                          >详情</el-button
                        >
                        <el-button
                          size="small"
                          type="text"
                          @click="remove(scope.row)"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <div slot="reference">
                    <div
                      class="day pointer flex flex-between"
                      :class="{ 'not-current-month': v.isCurentMonth !== 0 }"
                    >
                      <span v-if="v.count" class="badge">
                        {{ v.count }}
                      </span>
                      <span
                        :class="{ currentDay: currentDate.date === v.date }"
                        >{{ v.day }}</span
                      >
                      <span>{{ v.lunar }}</span>
                      <span
                        v-if="v.hasCheckedIn"
                        class="iconfont icon-gou2"
                      ></span>
                    </div>

                    <div v-if="calendarData3.length">
                      <div v-for="(item, index) in calendarData3" :key="index">
                        <div v-if="index < 2">
                          <el-popover
                            placement="right"
                            width="500"
                            trigger="hover"
                            :open-delay="1000"
                          >
                            <div class="p10 ">
                              <div class="flex flex-wrap one-plan">
                                <div
                                  class="one-plan-content"
                                  style="fontWeight:600"
                                >
                                  <div>
                                    计划名称：
                                  </div>
                                  <div>
                                    计划时间：
                                  </div>
                                  <div>
                                    计划描述：
                                  </div>
                                </div>
                                <div class="flex-1 one-plan-content">
                                  <div>
                                    {{ item.planName }}
                                  </div>
                                  <div>
                                    {{ item.startTime }}至{{ item.endTime }}
                                  </div>
                                  <div>
                                    {{ item.planRemark }}
                                  </div>
                                </div>
                              </div>

                              <div class="flex flex-center">
                                <el-button
                                  type="primary"
                                  size="small"
                                  @click="planDetails(item)"
                                  >查看计划详情</el-button
                                >
                              </div>
                            </div>
                            <div slot="reference">
                              <div
                                class="is-select-plan oneLine"
                                v-if="item.locateIndex[0] === k * 7 + i"
                                :style="
                                  `background:${item.color.background};color:${item.color.color};borderLeft:3px solid ${item.color.color}`
                                "
                              >
                                {{ item.planName }}
                              </div>

                              <div
                                v-if="
                                  item.locateIndex[0] < k * 7 + i &&
                                    k <= item.endRowIndex
                                "
                                class="is-select-plan oneLine"
                                :style="{
                                  background:
                                    item.locateIndex[0] < k * 7 + i &&
                                    item.locateIndex[
                                      item.locateIndex.length - 1
                                    ] >=
                                      k * 7 + i
                                      ? item.color.background
                                      : '',
                                  color:
                                    item.locateIndex[0] < k * 7 + i &&
                                    item.locateIndex[
                                      item.locateIndex.length - 1
                                    ] >=
                                      k * 7 + i
                                      ? item.color.color
                                      : '',
                                  borderLeft:
                                    (k * 7 + i) % 7 === 0
                                      ? `3px solid ${item.color.color}`
                                      : ''
                                }"
                              >
                                {{ (k * 7 + i) % 7 === 0 ? item.planName : "" }}
                              </div>
                            </div>
                          </el-popover>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-popover>
              </div>
              <div style="height:100%" v-if="k === 4">
                <el-popover
                  trigger="click"
                  class="item"
                  width="500"
                  placement="right"
                  :disabled="v.actList.length === 0"
                >
                  <el-table
                    :data="v.actList"
                    style="width: 100%"
                    size="small"
                    height="400"
                  >
                    <el-table-column
                      width="50"
                      prop="planName"
                      label="序号"
                      type="index"
                    ></el-table-column>
                    <el-table-column
                      prop="planName"
                      label="活动名称"
                    ></el-table-column>
                    <el-table-column
                      prop="startTime"
                      label="活动开始时间"
                    ></el-table-column>
                    <el-table-column
                      prop="endTime"
                      label="活动结束时间"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button
                          size="small"
                          type="text"
                          @click="planDetails(scope.row)"
                          >详情</el-button
                        >
                        <el-button
                          size="small"
                          type="text"
                          @click="remove(scope.row)"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <div slot="reference">
                    <div
                      class="day pointer flex flex-between"
                      :class="{ 'not-current-month': v.isCurentMonth !== 0 }"
                    >
                      <span v-if="v.count" class="badge">
                        {{ v.count }}
                      </span>
                      <span
                        :class="{ currentDay: currentDate.date === v.date }"
                        >{{ v.day }}</span
                      >
                      <span>{{ v.lunar }}</span>
                      <span
                        v-if="v.hasCheckedIn"
                        class="iconfont icon-gou2"
                      ></span>
                    </div>

                    <div v-if="calendarData4.length">
                      <div v-for="(item, index) in calendarData4" :key="index">
                        <div v-if="index < 2">
                          <el-popover
                            placement="right"
                            width="500"
                            trigger="hover"
                            :open-delay="1000"
                          >
                            <div class="p10 ">
                              <div class="flex flex-wrap one-plan">
                                <div
                                  class="one-plan-content"
                                  style="fontWeight:600"
                                >
                                  <div>
                                    计划名称：
                                  </div>
                                  <div>
                                    计划时间：
                                  </div>
                                  <div>
                                    计划描述：
                                  </div>
                                </div>
                                <div class="flex-1 one-plan-content">
                                  <div>
                                    {{ item.planName }}
                                  </div>
                                  <div>
                                    {{ item.startTime }}至{{ item.endTime }}
                                  </div>
                                  <div>
                                    {{ item.planRemark }}
                                  </div>
                                </div>
                              </div>

                              <div class="flex flex-center">
                                <el-button
                                  type="primary"
                                  size="small"
                                  @click="planDetails(item)"
                                  >查看计划详情</el-button
                                >
                              </div>
                            </div>
                            <div slot="reference">
                              <div
                                class="is-select-plan oneLine"
                                v-if="item.locateIndex[0] === k * 7 + i"
                                :style="
                                  `background:${item.color.background};color:${item.color.color};borderLeft:3px solid ${item.color.color}`
                                "
                              >
                                {{ item.planName }}
                              </div>

                              <div
                                v-if="
                                  item.locateIndex[0] < k * 7 + i &&
                                    k <= item.endRowIndex
                                "
                                class="is-select-plan oneLine"
                                :style="{
                                  background:
                                    item.locateIndex[0] < k * 7 + i &&
                                    item.locateIndex[
                                      item.locateIndex.length - 1
                                    ] >=
                                      k * 7 + i
                                      ? item.color.background
                                      : '',
                                  color:
                                    item.locateIndex[0] < k * 7 + i &&
                                    item.locateIndex[
                                      item.locateIndex.length - 1
                                    ] >=
                                      k * 7 + i
                                      ? item.color.color
                                      : '',
                                  borderLeft:
                                    (k * 7 + i) % 7 === 0
                                      ? `3px solid ${item.color.color}`
                                      : ''
                                }"
                              >
                                {{ (k * 7 + i) % 7 === 0 ? item.planName : "" }}
                              </div>
                            </div>
                          </el-popover>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-popover>
              </div>
              <div style="height:100%" v-if="k === 5">
                <el-popover
                  trigger="click"
                  class="item"
                  width="500"
                  placement="right"
                  :disabled="v.actList.length === 0"
                >
                  <el-table
                    :data="v.actList"
                    style="width: 100%"
                    size="small"
                    height="400"
                  >
                    <el-table-column
                      width="50"
                      prop="planName"
                      label="序号"
                      type="index"
                    ></el-table-column>
                    <el-table-column
                      prop="planName"
                      label="活动名称"
                    ></el-table-column>
                    <el-table-column
                      prop="startTime"
                      label="活动开始时间"
                    ></el-table-column>
                    <el-table-column
                      prop="endTime"
                      label="活动结束时间"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button
                          size="small"
                          type="text"
                          @click="planDetails(scope.row)"
                          >详情</el-button
                        >
                        <el-button
                          size="small"
                          type="text"
                          @click="remove(scope.row)"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <div slot="reference">
                    <div
                      class="day pointer flex flex-between"
                      :class="{ 'not-current-month': v.isCurentMonth !== 0 }"
                    >
                      <span v-if="v.count" class="badge">
                        {{ v.count }}
                      </span>
                      <span
                        :class="{ currentDay: currentDate.date === v.date }"
                        >{{ v.day }}</span
                      >
                      <span>{{ v.lunar }}</span>
                      <span
                        v-if="v.hasCheckedIn"
                        class="iconfont icon-gou2"
                      ></span>
                    </div>

                    <div v-if="calendarData5.length">
                      <div v-for="(item, index) in calendarData5" :key="index">
                        <div v-if="index < 2">
                          <el-popover
                            placement="right"
                            width="500"
                            trigger="hover"
                            :open-delay="1000"
                          >
                            <div class="p10 ">
                              <div class="flex flex-wrap one-plan">
                                <div
                                  class="one-plan-content"
                                  style="fontWeight:600"
                                >
                                  <div>
                                    计划名称：
                                  </div>
                                  <div>
                                    计划时间：
                                  </div>
                                  <div>
                                    计划描述：
                                  </div>
                                </div>
                                <div class="flex-1 one-plan-content">
                                  <div>
                                    {{ item.planName }}
                                  </div>
                                  <div>
                                    {{ item.startTime }}至{{ item.endTime }}
                                  </div>
                                  <div>
                                    {{ item.planRemark }}
                                  </div>
                                </div>
                              </div>

                              <div class="flex flex-center">
                                <el-button
                                  type="primary"
                                  size="small"
                                  @click="planDetails(item)"
                                  >查看计划详情</el-button
                                >
                              </div>
                            </div>
                            <div slot="reference">
                              <div
                                class="is-select-plan oneLine"
                                v-if="item.locateIndex[0] === k * 7 + i"
                                :style="
                                  `background:${item.color.background};color:${item.color.color};borderLeft:3px solid ${item.color.color}`
                                "
                              >
                                {{ item.planName }}
                              </div>

                              <div
                                v-if="
                                  item.locateIndex[0] < k * 7 + i &&
                                    k <= item.endRowIndex
                                "
                                class="is-select-plan oneLine"
                                :style="{
                                  background:
                                    item.locateIndex[0] < k * 7 + i &&
                                    item.locateIndex[
                                      item.locateIndex.length - 1
                                    ] >=
                                      k * 7 + i
                                      ? item.color.background
                                      : '',
                                  color:
                                    item.locateIndex[0] < k * 7 + i &&
                                    item.locateIndex[
                                      item.locateIndex.length - 1
                                    ] >=
                                      k * 7 + i
                                      ? item.color.color
                                      : '',
                                  borderLeft:
                                    (k * 7 + i) % 7 === 0
                                      ? `3px solid ${item.color.color}`
                                      : ''
                                }"
                              >
                                {{ (k * 7 + i) % 7 === 0 ? item.planName : "" }}
                              </div>
                            </div>
                          </el-popover>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-popover>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="rili" v-if="calendarType === 'month'">
      <div
        class="calendar_rili pointer"
        v-for="(items, index) in rili.datas"
        :key="index"
        @click="goMonth(index + 1)"
      >
        <div class="calendar_title">{{ index + 1 }}月</div>
        <div class="calendar_week">
          <span>周日</span><span>周一</span><span>周二</span><span>周三</span
          ><span>周四</span><span>周五</span><span>周六</span>
        </div>
        <div class="calendar_dateCon">
          <span
            v-for="(item, k) in items"
            v-html="changeDate(item.date)"
            :key="k"
          ></span>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1200px"
    >
      <el-dialog
        :title="title"
        :visible.sync="innerVisible"
        append-to-body
        :width="addActType === 'new' ? '1000px' : '1450px'"
      >
        <div v-if="addActType === 'new'">
          <div class="mb20">
            <span style="fontWeight:600">
              {{ row.planName }}
            </span>
            (<span :style="`color:${row.color.color}`">
              {{ row.startTime + "至" + row.endTime }} </span
            >)
          </div>
          <div class="flex flex-around mb20">
            <div
              style="width:200px"
              class="pointer"
              v-for="(v, i) in actImgList"
              :key="i"
              @click="toAdd(v.router)"
            >
              <img style="width:100%" :src="v.img" alt="" />
            </div>
          </div>
        </div>
        <div v-if="addActType === 'old'">
          <div class="flex item-center">
            <hm-actTransfer ref="actTransfer" showAttribute></hm-actTransfer>
          </div>
          <span slot="footer" class="mt10 dialog-footer flex flex-center">
            <el-button @click="confirm" size="small" type="primary"
              >保 存</el-button
            >
            <el-button @click="innerVisible = false" size="small" type="primary"
              >关 闭</el-button
            >
          </span>
        </div>
      </el-dialog>
      <div slot="title" class="flex flex-between">
        <div>
          <span>
            {{ row.planName }}
          </span>
          <span :style="`color:${row.color.color}`">
            ({{ row.startTime + "至" + row.endTime }})
          </span>
          <el-button size="small" type="text" class="ml10" @click="remove(row)"
            >删除计划</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table
          :data="planActList"
          style="width: 100%"
          size="small"
          height="400"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="活动分类"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.activityType === 'promotion'">
                促销
              </div>
              <div v-if="scope.row.activityType === 'coupon'">
                优惠券
              </div>
              <div v-if="scope.row.activityType === 'game'">
                营销
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="activeName"
            label="活动名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="activeModel"
            label="活动类型"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="活动优先级"
          >
            <template slot-scope="scope">
              <div>
                1
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="活动时间"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.activeStartTime }}至{{ scope.row.activeEndTime }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="activeStatus"
            label="活动状态"
          ></el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button
                  size="small"
                  type="text"
                  class="blue"
                  @click="details(scope.row)"
                  >查 看</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  class="danger"
                  @click="del(scope.row)"
                  >移 除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="mt20">
        <el-button type="primary" size="small" @click="addAct('old')"
          >添加已有活动</el-button
        >
        <el-button type="primary" size="small" @click="addAct('new')"
          >添加新活动</el-button
        >
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <!-- <el-button @click="save" size="small" type="primary">保存</el-button> -->
        <el-button @click="dialogVisible = false" size="small" type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <!-- <div class="calendar-body" v-if="false">
      <div class="weeks flex flex-between">
        <div class="flex-1 flex flex-center" v-for="(v, i) in weeks" :key="i">
          {{ v }}
        </div>
      </div>
      <tr
        class="days flex flex-between"
        v-for="(j, k) in calendarList"
        :key="k"
      >
        <td v-for="(v, i) in j" :key="i" class="flex-1">
          <div class="pc-calendar-day" @click="selectDay(v)">
            <div
              class="day pointer"
              :class="{ 'not-current-month': v.isCurentMonth !== 0 }"
            >
              <span v-if="v.count" class="badge">
                {{ v.count }}
              </span>
              <span :class="{ currentDay: currentDate.date === v.date }">{{
                v.day
              }}</span>
              <span v-if="v.hasCheckedIn" class="iconfont icon-gou2"></span>
            </div>
          </div>
        </td>
      </tr>
    </div> -->
  </div>
</template>

<script>
import moment from "moment";

import { arrayUnique2, toLunar, group } from "@/utils/utils";
import HmActTransfer from "@/components/actTransfer";
export default {
  components: {
    HmActTransfer
  },
  props: {
    checkedInDays: {
      type: Array,
      default: () => []
    },
    actDays: {
      type: Array,
      default: () => []
    }
  },
  data() {
    function getMonth(year) {
      var year = year || 2018;
      var dayMseconds = 86400000;
      var monthArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      var resultArr = [];

      function isRun() {
        //判断是否是闰年
        if (year % 400 == 0 || (year % 4 == 0 && year % 100 != 0)) {
          return true;
        } else {
          return false;
        }
      }

      var run = isRun();
      for (var m = 1; m < 13; m++) {
        var arr = [];
        var firstday = new Date(year + "-" + m + "-01").getTime(); //拿到时间戳
        var lastday = 30;
        var weekDay = new Date(firstday).getDay(); //根据时间戳，拿到本月第一天的星期
        var weekLastDay = weekDay + 31; //拿到本月最后一天的星期
        switch (m) {
          case 2:
            if (run) {
              lastday = new Date(year + "-" + m + "-29").getTime();
              weekLastDay = weekDay + 29;
            } else {
              lastday = new Date(year + "-" + m + "-28").getTime();
              weekLastDay = weekDay + 28;
            }
            break;
          case 4:
            lastday = new Date(year + "-" + m + "-30").getTime();
            weekLastDay = weekDay + 30;
            break;
          case 6:
            lastday = new Date(year + "-" + m + "-30").getTime();
            weekLastDay = weekDay + 30;
            break;
          case 9:
            lastday = new Date(year + "-" + m + "-30").getTime();
            weekLastDay = weekDay + 30;
            break;
          case 11:
            lastday = new Date(year + "-" + m + "-30").getTime();
            weekLastDay = weekDay + 30;
            break;

          default:
            lastday = new Date(year + "-" + m + "-31").getTime(); //拿到时间戳
            weekLastDay = weekDay + 31;
            break;
        }

        var n = 0;
        for (var i = 0; i < 42; i++) {
          var content = { date: "", class: "" };
          if (i < weekDay || i > weekLastDay - 1) {
            arr.push(content);
          } else {
            n++;
            arr.push({
              day: new Date(firstday + dayMseconds * n - dayMseconds).getDate(),
              date: firstday + dayMseconds * n - dayMseconds,
              class: ""
            });
          }
        }
        resultArr.push(arr);
      }
      return resultArr;
      // document.getElementById('box').innerHTML = JSON.stringify(arr);
    }

    return {
      actName: "",
      status: "cx",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      planActList: [],
      row: {
        color: {}
      },
      innerVisible: false,
      dialogVisible: false,
      rili: {
        year: new Date().getFullYear(),
        datas: getMonth(new Date().getFullYear())
      },
      calendarType: "day",
      dayTip: "",
      calendarData: this.actDays,
      currentDate: {
        date: ""
      },
      calendarList: [],
      isSelectYears: false,
      isSelectMonth: false,
      weeks: ["日", "一", "二", "三", "四", "五", "六"],
      currentDay: new Date().getDate(),
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      today: moment().format("YYYY/MM/DD"),
      weeks0: [0, 1, 2, 3, 4, 5, 6],
      weeks0Flag: false,
      weeks1: [7, 8, 9, 10, 11, 12, 13],
      weeks1Flag: false,
      weeks2: [14, 15, 16, 17, 18, 19, 20],
      weeks2Flag: false,
      weeks3: [21, 22, 23, 24, 25, 26, 27],
      weeks3Flag: false,
      weeks4: [28, 29, 30, 31, 32, 33, 34],
      weeks4Flag: false,
      weeks5: [35, 36, 37, 38, 39, 40, 41],
      weeks5Flag: false,
      weekRow: [],
      calendarData0: [],
      calendarData1: [],
      calendarData2: [],
      calendarData3: [],
      calendarData4: [],
      calendarData5: [],
      addActType: "",
      title: "",
      actImgList: [
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/cx%402x.png",
          router: "SelectActivity"
        },
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/yx%402x.png",
          router: "CreateActivity"
        },
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/yh%402x.png",
          router: "AddCoupons"
        }
      ],
      clickTimes: 0,
      list: []
    };
  },
  created() {
    // this.currentDate.date = this.today;
    // this.dayTip =
    //   moment().format("MM月DD日 周") + this.weeks[new Date().getDay()];
    // this.$emit("switchDay", moment().format("YYYY/MM/DD"));
    // this.getStartAndEndDay();
    this.goToday();
    for (let i = 0; i <= 41; i++) {
      this.weekRow.push(i);
    }
  },
  mounted() {
    // this.calendarList.forEach((v, i) => {
    //   if (i === 0) {
    //     v.forEach(v => {
    //       v.flag = this.weeks0Flag;
    //     });
    //   }
    // });
  },
  computed: {
    days() {
      const now = `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;
      const lastMonth = this.getlastMonthDays(now);
      const currentMonth = this.getCurrentMonthDays(now);
      const nextMonth = this.getNextMonthDays({
        now,
        currentMonthLength: currentMonth.length,
        lastMonthLength: lastMonth.length
      });
      this.list = lastMonth.concat(currentMonth).concat(nextMonth);

      this.list.forEach(v => {
        // v.date = v.date.replace(/\//g, "-");
        v.actList = [];
        v.lunar = toLunar(
          v.date.split("/")[0],
          v.date.split("/")[1],
          v.date.split("/")[2]
        );
        v.days = v.date
          .split("-")
          .slice(2)
          .join("-");
      });

      this.queryPlanTimeList(
        this.list[0].date.replace(/\//g, "-"),
        this.list[this.list.length - 1].date.replace(/\//g, "-")
      );
      this.$emit("selectDay", {
        startTime: moment(now).format("YYYY/MM/DD")
      });
      // list.forEach((v, i) => {
      //   this.calendarData.forEach(j => {
      //     j.locateIndex.forEach(x => {
      //       if (i === x) {
      //         v.actList.push(j);
      //       }
      //     });
      //   });
      // });
      const displayedMonth = group(
        lastMonth.concat(currentMonth).concat(nextMonth),
        7
      );
      this.calendarList = displayedMonth;

      return displayedMonth;
    }
  },
  watch: {
    days(val) {
      this.calendarList = val;
    },
    checkedInDays(val) {
      val.map(o => {
        this.calendarList.forEach(v => {
          if (v.date === o) {
            v.hasCheckedIn = true;
          }
        });
      });
      this.$forceUpdate();
    },
    actDays(list) {
      this.calendarData = list;
      this.queryList();
    },
    currentDate(val) {}
  },
  methods: {
    remove(row) {
      this.$confirm("确定删除该计划?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteActivePlan", {
            id: row.id
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.dialogVisible = false;
              this.queryPlanTimeList(
                this.list[0].date.replace(/\//g, "-"),
                this.list[this.list.length - 1].date.replace(/\//g, "-")
              );
            }
          });
      });
    },
    details(row) {
      if (row.activityType === "game") {
        if (row.activeCode === "turntable") {
          let routeData = this.$router.resolve({
            name: "DetailsWheelAct",
            query: {
              type: true,
              gameType: row.activeCode,
              gameId: row.activityId
            }
          });
          window.open(routeData.href, "_blank");
          // this.$router.push({
          //   name: "DetailsWheelAct",
          //   query: {
          //     type: true,
          //     gameType: row.activeCode,
          //     gameId: row.activityId
          //   }
          // });
        } else if (row.activeCode === "seckill") {
          let routeData = this.$router.resolve({
            name: "DetailsSeckillAct",
            query: {
              type: true,
              gameType: row.activeCode,
              gameId: row.activityId
            }
          });
          window.open(routeData.href, "_blank");
          // this.$router.push({
          //   name: "DetailsSeckillAct",
          //   query: {
          //     type: true,
          //     gameType: row.activeCode,
          //     gameId: row.activityId
          //   }
          // });
        } else if (row.activeCode === "bargain") {
          let routeData = this.$router.resolve({
            name: "DetailsBargainAct",
            query: {
              type: true,
              gameType: row.activeCode,
              gameId: row.activityId
            }
          });
          window.open(routeData.href, "_blank");
          // this.$router.push({
          //   name: "DetailsBargainAct",
          //   query: {
          //     type: true,
          //     gameType: row.activeCode,
          //     gameId: row.activityId
          //   }
          // });
        } else if (row.activeCode === "lottery_team") {
          let routeData = this.$router.resolve({
            name: "DetailsLotteryAct",
            query: {
              type: true,
              gameType: row.activeCode,
              gameId: row.activityId
            }
          });
          window.open(routeData.href, "_blank");

          // this.$router.push({
          //   name: "DetailsLotteryAct",
          //   query: {
          //     type: true,
          //     gameType: row.activeCode,
          //     gameId: row.activityId
          //   }
          // });
        } else if (row.activeCode === "bargains_team") {
          let routeData = this.$router.resolve({
            name: "DetailsSpecialAct",
            query: {
              type: true,
              gameType: row.activeCode,
              gameId: row.activityId
            }
          });
          window.open(routeData.href, "_blank");
          // this.$router.push({
          //   name: "DetailsSpecialAct",
          //   query: {
          //     type: true,
          //     gameType: row.activeCode,
          //     gameId: row.activityId
          //   }
          // });
        } else if (row.activeCode === "leader_free_team") {
          let routeData = this.$router.resolve({
            name: "DetailsLeaderFree",
            query: {
              type: true,
              gameType: row.activeCode,
              gameId: row.activityId
            }
          });
          window.open(routeData.href, "_blank");
          // this.$router.push({
          //   name: "DetailsLeaderFree",
          //   query: {
          //     type: true,
          //     gameType: row.activeCode,
          //     gameId: row.activityId
          //   }
          // });
        }
      } else if (row.activityType === "promotion") {
        let routeData = this.$router.resolve({
          name: "ActivityDetails",
          query: {
            id: row.activityId,
            type: row.auditState,
            parentId: row.activeCode.split("-")[0],
            mode: "view"
          }
        });
        window.open(routeData.href, "_blank");
        // this.$router.push({
        //   name: "ActivityDetails",
        //   query: {
        //     id: row.activityId,
        //     type: row.auditState,
        //     parentId: row.activeCode.split("-")[0],
        //     mode: "view"
        //   }
        // });
      } else if (row.activityType === "coupon") {
        let routeData = this.$router.resolve({
          name: "AddCoupons",
          query: { type: "edit", couponSendId: row.activityId }
        });
        window.open(routeData.href, "_blank");
        // this.$router.push({
        //   name: "AddCoupons",
        //   query: { type: "edit", couponSendId: row.activityId }
        // });
      }
    },
    async del(row) {
      const result = await this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });

      if (result === "confirm") {
        const { code } = await this.$store.dispatch("removActivePlanRel", {
          id: row.id
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryPlanActList();
        }
      }
    },
    async confirm() {
      if (this.$refs.actTransfer.rightData.length) {
        let planRelModelList = JSON.parse(
          JSON.stringify(this.$refs.actTransfer.rightData)
        );
        planRelModelList.forEach(v => {
          if (this.$refs.actTransfer.avtType === "cx") {
            v.activityType = "promotion";
          } else if (this.$refs.actTransfer.avtType === "yx") {
            v.activityType = "game";
          } else if (this.$refs.actTransfer.avtType === "ff") {
            v.activityType = "coupon";
          }
        });
        let params = {
          planRelModelList,
          id: this.row.id
        };
        const { code } = await this.$store.dispatch("addActivePlanRel", params);
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.innerVisible = false;
          this.queryPlanActList();
        }
      } else {
        this.$message({
          message: "请选择活动!",
          type: "warning"
        });
      }
    },
    toAdd(router) {
      this.$router.push({
        name: router,
        query: { type: "add" }
      });
    },
    async queryPlanTimeList(statrtDate, endDate) {
      let params = {
        startTime: `${statrtDate} 00:00:00`,
        endTime: `${endDate} 23:59:59`
      };
      //获取当前日历开始日期和结束日期
      const { result } = await this.$store.dispatch(
        "queryPlanTimeList",
        params
      );
      this.calendarData = result;

      if (this.calendarData.length) {
        this.calendarData.forEach(item => {
          item.color = {
            color: item.color,
            background: item.color.slice(0, -1) + ",0.3" + item.color.slice(-1)
          };
        });

        // this.calendarList.forEach((v, i) => {
        //   v.forEach((j, k) => {
        //     this.calendarData.forEach(a => {
        //       a.locateIndex.forEach(b => {
        //         if (b === k * 7 + i) {
        //           j.actList.push(a);
        //         }
        //       });
        //     });
        //   });
        // });
      }

      this.queryList();
    },
    queryList() {
      this.calendarData0 = [];
      this.calendarData1 = [];
      this.calendarData2 = [];
      this.calendarData3 = [];
      this.calendarData4 = [];
      this.calendarData5 = [];
      this.calendarData.forEach(v => {
        if (this.weekRow.indexOf(v.locateIndex[0]) > 0) {
          v.startRowIndex = this.getRowIndex(v.locateIndex[0]);
        }
        if (this.weekRow.indexOf(v.locateIndex[v.locateIndex.length - 1]) > 0) {
          v.endRowIndex = this.getRowIndex(
            v.locateIndex[v.locateIndex.length - 1]
          );
        }
        this.weekRow.filter(num => {
          if (v.locateIndex.indexOf(num) !== -1) {
            if (this.getRowIndex(num) === 0) {
              this.calendarData0.push(v);
            } else if (this.getRowIndex(num) === 1) {
              this.calendarData1.push(v);
            } else if (this.getRowIndex(num) === 2) {
              this.calendarData2.push(v);
            } else if (this.getRowIndex(num) === 3) {
              this.calendarData3.push(v);
            } else if (this.getRowIndex(num) === 4) {
              this.calendarData4.push(v);
            } else if (this.getRowIndex(num) === 5) {
              this.calendarData5.push(v);
            }
          }
          // return this.weekRow.indexOf(num) !== -1;
        });
      });
      for (let k = 0; k <= 5; k++) {
        this[`calendarData${k}`] = arrayUnique2(
          this[`calendarData${k}`],
          "planName"
        );
      }
      this.calendarList.forEach((v, i) => {
        v.forEach((c, k) => {
          this.calendarData.forEach(item => {
            item.locateIndex.forEach(o => {
              if (o === i * 7 + k) {
                c.actList.push(item);
              }
            });
          });
        });
      });

      this.calendarData = this.calendarData;
      this.$forceUpdate();
    },
    switchTab(val) {},
    addAct(addActType) {
      if (addActType === "new") {
        this.title = "添加新活动";
      } else {
        this.title = "添加已有活动";
      }
      this.addActType = addActType;
      this.innerVisible = true;
    },
    save() {},
    paging(page) {
      this.currentPage = page;
      this.queryPlanActList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryPlanActList();
    },
    async queryPlanActList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        id: this.row.id
      };
      const { result } = await this.$store.dispatch(
        "queryActivePlanRelList",
        params
      );
      this.planActList = result.records;
      this.total = result.total;
    },
    async planDetails(item) {
      this.row = item;
      this.dialogVisible = true;
      this.currentPage = 1;
      this.pageSize = 10;
      this.queryPlanActList();
    },
    goToday() {
      this.calendarType = "day";
      this.currentDate.date = this.today;
      this.dayTip =
        moment().format("MM月DD日 周") + this.weeks[new Date().getDay()];
      this.$emit("switchDay", moment().format("YYYY/MM/DD"));
      this.getStartAndEndDay();
    },
    getRowIndex(i) {
      for (let k = 0; k <= 5; k++) {
        if (this[`weeks${k}`].indexOf(i) !== -1) {
          return k;
        }
      }
    },
    goMonth(i) {
      this.currentMonth = i;
      const now = `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;
      this.$emit("changePcMonth", moment(now).format("YYYY/MM/DD"));
      this.calendarType = "day";
    },
    changeDate(date) {
      if (date) {
        return new Date(date).getDate();
      } else {
        return "";
      }
    },
    // 获取上一个月的开始结束时间
    getLastMonthLastDay(now) {
      const start =
        moment(now)
          .subtract(1, "month")
          .format("YYYY/MM") + "/01";
      const end = parseInt(
        moment(start)
          .subtract(-1, "month")
          .add(-1, "days")
          .format("D")
      );
      return end;
    },
    // 获取当前月的天数
    getCurrentMonthDays(now) {
      const currentMonth = [];
      // 本月第一天
      const start =
        moment(now)
          .add(0, "month")
          .format("YYYY/MM") + "/01";
      // 本月最后一天
      const end = parseInt(
        moment(start)
          .add(1, "month")
          .add(-1, "days")
          .format("D")
      );
      const datePrefix = moment(now).format("YYYY/MM");

      for (let i = 1; i < end + 1; i++) {
        const day = i < 10 ? "0" + i : i;
        currentMonth.push({
          day: i,
          isCurentMonth: 0, // 代表本月
          date: `${datePrefix}/${day}`,
          count: 0
        });
      }
      return currentMonth;
    },
    getlastMonthDays(now) {
      // 本月第一天
      const start =
        moment(now)
          .add(0, "month")
          .format("YYYY/MM") + "/01";
      // 本月第一天是周几
      const weekOfday = parseInt(moment(start).format("d"));

      const lastMonth = [];
      const lastMonthEnd = this.getLastMonthLastDay(now);
      let lastMonthStart = null;
      //
      if (weekOfday === 0) {
        lastMonthStart = lastMonthEnd - 6;
      } else {
        lastMonthStart = lastMonthEnd - (weekOfday - 1);
      }
      const datePrefix = moment(now)
        .subtract(1, "months")
        .format("YYYY/MM");
      for (let i = lastMonthStart; i < lastMonthEnd + 1; i++) {
        const day = i < 10 ? "0" + i : i;
        lastMonth.push({
          day: i,
          isCurentMonth: -1, // 代表上月
          date: `${datePrefix}/${day}`,
          count: 0
        });
      }
      return lastMonth;
    },
    getNextMonthDays({
      now,
      maxdays = 42,
      currentMonthLength,
      lastMonthLength
    }) {
      const nextMonth = [];
      // 获取日历当前月显示的下月最后一天
      const nextMonthEndDay = maxdays - currentMonthLength - lastMonthLength;
      const datePrefix = moment(now)
        .add(1, "months")
        .format("YYYY/MM");
      for (let i = 1; i < nextMonthEndDay + 1; i++) {
        const day = i < 10 ? "0" + i : i;
        nextMonth.push({
          day: i,
          isCurentMonth: 1, // 代表下个月
          date: `${datePrefix}/${day}`,
          count: 0
        });
      }
      return nextMonth;
    },
    selectDay(date) {
      //  单击模拟双击操作
      this.clickTimes++;
      if (this.clickTimes === 2) {
        //当点击次数为2
        this.clickTimes = 0; //记得清零
        //  触发双击事件...
        this.$emit("double");
      }
      let _this = this;
      setTimeout(() => {
        if (_this.clickTimes === 1) {
          _this.clickTimes = 0; // 单击清零
          //  触发单击事件...
          const { day, isCurentMonth } = date;
          if (isCurentMonth === -1) {
            this.currentMonth--;
            this.formatDate();
          } else if (isCurentMonth === 1) {
            this.currentMonth++;
            this.formatDate();
          }
          this.currentDay = day;
          this.currentDate = date;

          this.$emit("switchDay", moment(date.date).format("YYYY/MM/DD"));
          this.dayTip =
            moment(date.date).format("MM月DD日 周") +
            this.weeks[new Date(date.date).getDay()];
        }
      }, 250);
    },
    toLastYear() {
      this.currentYear--;
      this.currentDay = 1;
      this.formatDate();
    },
    toLastMonth() {
      this.currentMonth--;
      this.currentDay = 1;
      this.formatDate();
      const now = `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;

      this.$emit("changePcMonth", moment(now).format("YYYY/MM/DD"));
      this.$emit("goMonth", this.currentMonth);
    },
    toNextMonth() {
      this.currentMonth++;
      this.currentDay = 1;
      this.formatDate();
      const now = `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;
      this.$emit("changePcMonth", moment(now).format("YYYY/MM/DD"));
      this.$emit("goMonth", this.currentMonth);
    },
    changeDays(currentYear, currentMonth) {
      this.currentYear = currentYear;
      this.currentMonth = currentMonth;
      this.currentDay = 1;
      this.formatDate();
      const now = `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;
      this.$emit("changeMonth", moment(now).format("YYYY/MM/DD"));
    },
    toNextYear() {
      this.currentYear++;
      this.currentDay = 1;
      this.formatDate();
    },
    formatDate() {
      if (this.currentMonth > 12) {
        this.currentYear++;
        this.currentMonth = 1;
      } else if (this.currentMonth < 1) {
        this.currentYear--;
        this.currentMonth = 12;
      }
    },
    getCalendarDays() {
      const now = `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;
      const lastMonth = this.getlastMonthDays(now);
      const currentMonth = this.getCurrentMonthDays(now);
      const nextMonth = this.getNextMonthDays({
        now,
        currentMonthLength: currentMonth.length,
        lastMonthLength: lastMonth.length
      });
      const displayedMonth = lastMonth.concat(currentMonth).concat(nextMonth);
      this.$emit("selectDay", {
        currentDate: moment(now).format("YYYY/MM/DD")
      });
      /*eslint vue/no-side-effects-in-computed-properties: [0] */
      this.calendarList = displayedMonth;
      return displayedMonth;
    },
    getStartAndEndDay() {
      const now = `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;
      const lastMonth = this.getlastMonthDays(now);
      const currentMonth = this.getCurrentMonthDays(now);
      const nextMonth = this.getNextMonthDays({
        now,
        currentMonthLength: currentMonth.length,
        lastMonthLength: lastMonth.length
      });
      const statrtDate = this.getlastMonthDays(now)[0].date;
      const endDate = nextMonth[nextMonth.length - 1].date;
      this.$emit("getStartAndEndDay", {
        statrtDate,
        endDate
      });
    }
  }
};
</script>
<style lang="scss">
.pc-calendar-day {
  .el-popover__reference {
    height: 100%;
  }
}
</style>
<style scoped lang="scss">
$dayWidth: 100px;
$calendarWidth: $dayWidth * 7;
.calendar {
  //   width: $calendarWidth;
  margin: 0 auto;
  padding: 24px;
  //   color: #fff;
  &-header {
    margin-bottom: 24px;
    user-select: none;
  }
  .el-calendar-table {
    table-layout: fixed;
    width: 100%;
  }
  .weeks {
    padding: 24px 0;
  }

  .days {
    // padding: 24px 0 0;
    // border-bottom: 1px solid #ebeef5;
    .pc-calendar-day {
      height: 130px;
      box-sizing: border-box;
      //   padding: 8px;
    }
  }
  .week {
    // width: $dayWidth;
    text-align: center;
  }
  .day {
    height: 34px;
    // width: 34px;
    line-height: 34px;
    padding: 0 8px;
    // position: relative;
    // width: $dayWidth;
    // height: $dayWidth;
    // line-height: $dayWidth;
    // text-align: center;
    // transition: all 0.2s linear;
    // color: #fff;
    // border-right: 1px solid #ebeef5;
    .iconfont {
      position: absolute;
      bottom: -40px;
      left: 50%;
      transform: translateX(-50%);
      color: #2fc348;
      font-size: 24px;
    }
    .currentDay {
      text-align: center;
      display: inline-block;
      background: #e50065;
      border-radius: 50%;
      height: 34px;
      width: 34px;
      line-height: 34px;
      color: #fff;
    }
    .badge {
      position: absolute;
      right: 43px;
      top: 16px;
      background-color: #e98c00;
      border-radius: 10px;
      //   color: #fff;
      display: inline-block;
      font-size: 12px;
      height: 18px;
      line-height: 18px;
      padding: 0 6px;
      text-align: center;
      white-space: nowrap;
      transform: translateY(-50%) translateX(100%);
    }
  }
  .not-current-month {
    // color: #fff;
    opacity: 0.5;
  }
  .day-tip {
    width: 328px;
    height: 52px;
    line-height: 52px;
    background: rgba(255, 255, 255, 1);
    border-radius: 12px;
    margin: 0 auto;
    color: #005ceb;
    text-align: center;
  }
}

.rili {
  float: left;
  padding-left: 20px;
  font-size: 12px;
  overflow: hidden;
  // min-width: 1050px;
  width: 100%;
}

.calendar_rili {
  float: left;
  width: 23%;
  border: 1px solid #bebfc1;
  margin-right: 20px;
  margin-top: 20px;
  height: 230px;
}

.calendar_rili .calendar_title {
  padding: 0.5em 0 0.5em 0;
  text-align: center;
  border-bottom: 1px solid #bebfc1;
}

.calendar_rili .calendar_week {
  padding: 0.5em 0 0.5em 0;
}

.calendar_rili .calendar_week span {
  width: 14.2857%;
  text-align: center;
  display: inline-block;
}

.calendar_rili .calendar_dateCon span {
  padding: 0.5em 0 0.5em 0;
  width: 14.2857%;
  text-align: center;
  display: block;
  float: left;
}

.one-plan {
  .one-plan-content {
    > div {
      margin: 10px 0;
    }
  }
}
</style>
